var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('apexchart',{staticClass:"ml-5",attrs:{"width":"700","height":"400","type":_vm.series.type,"options":_vm.options,"series":_vm.series}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }